import React, { useRef, useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import "./module.css";
import { Helmet } from "react-helmet";

function ContactUs() {
  const [submitted, setSubmitted] = useState(false);
  const [cooldown, setCooldown] = useState(false);

  useEffect(() => {
    if (cooldown) {
      // Start the cooldown timer
      const cooldownTimer = setTimeout(() => {
        setCooldown(false);
      }, 10000); // 1 Minute cooldown

      // Clear the timer when the component unmounts or cooldown is reset
      return () => clearTimeout(cooldownTimer);
    }
  }, [cooldown]);

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    // Prevent submission during cooldown period
    if (cooldown) {
      return;
    }

    emailjs
      .sendForm("service_1znzuh7", "template_wq66geb", form.current, {
        publicKey: "Tkc_DuArwUPCZZqsR",
      })
      .then(
        () => {
          console.log("SUCCESS!");
          setSubmitted(true);
          setCooldown(true);

          // Reset the form after 10 seconds
          setTimeout(() => {
            setSubmitted(false);
            setCooldown(false);
          }, 100000); // 1 Minute cooldown
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
  };

  return (
    <>
      <div className="contact">
      <Helmet>
        <title>Fabits - Contact Us</title>
        <meta name="description" content="Reach out to us" />
      </Helmet>
        <h2 id="wish">Wish to Speak with Us?</h2>
        <p id="belowwish">An accompanying subtitle text for this page</p>
        <img src="/ContactUs/Group 32.svg" alt="Group 32" id="group39" />
        <img
          src="/ContactUs/righttopmobile.svg"
          alt="righttopmobile"
          id="righttopmobile"
        />
        <img src="/ContactUs/leftmiddle.svg" alt="leftmiddle" id="leftmiddle" />
        <img
          src="/ContactUs/rightbottem.svg"
          alt="rightbottem"
          id="rightbottem"
        />
        <img src="/ContactUs/Frame.svg" alt="frame" id="frame1" />
        <div className="buttons">
          <div id="chatwithus">
            <img src="/ContactUs/Chatwithus.svg" alt="chat" id="chat" />
            <div id="chatwithusdiv">
              <a href="https://wa.me/+8217801975?text=Hi!+I+am+looking+to+get+some+help+regarding+Fabits." id="chatlink">
                {/* LINK TO CHAT WITH US */}
                <h3>Chat with us </h3>
                <img
                  src="/ContactUs/arrowlink.svg"
                  alt="arrow"
                  id="arrowlink"
                />
              </a>
              <p id="sec">Est. wait time 100 secs.</p>
            </div>
          </div>

          <div id="call">
            <img src="/ContactUs/Callicon.svg" alt="call" id="callicon" />
            <div id="calldiv">
              {/* LINK TO call link */}
              <a href="tel:+918217801975" id="calllink">
                <h3>Call Us</h3>
                <img
                  src="/ContactUs/arrowlink.svg"
                  alt="arrow"
                  id="arrowlink"
                />
              </a>
              <p id="mins">Est. wait time 3 mins.</p>
            </div>
          </div>

          <div id="shedulediv">
            <img src="/ContactUs/shedule.svg" alt="shedule" id="shedule" />
            {/* LINK TO shedule a call link */}
            <div id="sheduledivin">
              <a href="https://calendly.com/fabits" id="shedulelink">
                <h3>Schedule a call</h3>
                <img
                  src="/ContactUs/arrowlink.svg"
                  alt="arrow"
                  id="arrowlink"
                />
              </a>
              <p>Est. wait time 24 working hrs.</p>
            </div>
          </div>
        </div>
      </div>
      <div className="contactus">
        <img src="/ContactUs/Vector.png" alt="vector" id="vector" />
        <img src="/ContactUs/vectorleft.svg" alt="vectorleft" id="vectorleft" />
        <h3>Got more questions?</h3>
        <p>Get in touch with us today!</p>
        <div className="contactusform">
          <form id="contactusforminner" onSubmit={sendEmail} ref={form}>
            <div className="form1and2">
              <div className="form1">
                <label htmlFor="name" id="namelabel">
                  Full name
                </label>
                <input
                  type="text"
                  id="name"
                  name="from_name"
                  maxLength={100}
                  placeholder="e.g.Surya Karthik"
                />
              </div>
              <div className="form2">
                <label htmlFor="email" id="emaillabel">
                  Email address*
                </label>
                <br />
                <input
                  required
                  type="email"
                  id="email"
                  maxLength={50}
                  name="from_email"
                  placeholder="e.g.G.Suryakarthik@mail.com"
                />
              </div>
            </div>
            <div className="form3">
              <div className="phonenumberformcontactus">
                <label htmlFor="query" id="querylabel">
                  What is your query regarding?
                </label>
                <br />
                <select name="query" id="query">
                  <option value="">Select a reason</option>
                  <option value="general">General</option>
                  <option value="payment">Payment</option>
                  <option value="technical">Technical</option>
                  <option value="others">Others</option>
                </select>
              </div>
              <div className="phonenumberformcontactus">
                <label htmlFor="phone" id="emaillabel">
                  Phone number
                </label>
                <br />
                <input
                  type="tel"
                  id="email"
                  name="phone_number"
                  maxLength={10}
                  placeholder="e.g.9876543210"
                />
              </div>
            </div>
            <div className="form4">
              <label htmlFor="message" id="describelabel">
                Describe your query
              </label>
              <br />
              <textarea
                name="message"
                id="message"
                cols="30"
                rows="10"
                maxLength={600}
                placeholder="Query description..."
              ></textarea>
            </div>
            <button
              id="submit"
              type="submit"
              value="Send"
              disabled={submitted || cooldown}
              className={submitted ? "submitted" : ""}
            >
              {submitted
                ? "Your query is submitted Please wait 1 Minute"
                : "Submit Query"}
            </button>
          </form>
          
        </div>
        
      </div>
      <div className="escalate-matrix-container">
      <table class="escalate-matrix">
  <tr>
    <td colspan="4" class="title">Follow our Escalate Matrix here</td>
  </tr>
  <tr class="bold-row">  <th class="heading">Details Of</th>
    <th class="heading">Name</th>
    <th class="heading">Contact No</th>
    <th class="heading">Email ID</th>
  </tr>
  <tr>
    <td class="content">Customer Care</td>
    <td class="content">Jeeva S</td>
    <td class="content">8050030909</td>
    <td class="content">support@fabits.com</td>
  </tr>
  <tr>
    <th class="heading">Head  of customer care</th>
    <td class="content">Ramesh L</td>
    <td class="content">9841455600</td>
    <td class="content">ramesh@fabits.com</td>
  </tr>
  <tr>
    <th class="heading">Compliance Officer</th>
    <td class="content">Rathi R</td>
    <td class="content">9742456907</td>
    <td class="content">rathi@fabits.com</td>
  </tr>
  <tr>
    <td class="content">CEO</td>
    <td class="content">Ajath Anjanappa</td>
    <td class="content">9986331582</td>
    <td class="content">ajath@fabits.com</td>
  </tr>
</table>
</div>
    </>
  );
}

export default ContactUs;
